import { render } from "./_id.vue?vue&type=template&id=2368cae6&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"

import "./_id.vue?vue&type=style&index=0&id=2368cae6&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/oztagaustralia-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2368cae6"]])

export default __exports__